var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7995",
    "data-name": "Rectangle 7995",
    width: 60,
    height: 60,
    fill: "#e6e8f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7998",
    "data-name": "Rectangle 7998",
    width: 28.035,
    height: 41.923,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7997",
    "data-name": "Rectangle 7997",
    width: 28.035,
    height: 41.924,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7996",
    "data-name": "Rectangle 7996",
    width: 28.035,
    height: 36.939,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32605",
    "data-name": "Group 32605",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32612",
    "data-name": "Group 32612",
    transform: "translate(15.982 9.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32611",
    "data-name": "Group 32611",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32610",
    "data-name": "Group 32610",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32609",
    "data-name": "Group 32609",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34708",
    "data-name": "Path 34708",
    d: "M26.018,40.432c0,1.642-5.33,2.977-11.919,2.977S2.18,42.075,2.18,40.432c0-1.354,3.64-2.507,8.615-2.862,1.441,1.681,2.449,2.776,2.6,2.939l.711.759.7-.759c.154-.163,1.162-1.258,2.593-2.939,4.975.355,8.615,1.508,8.615,2.862",
    transform: "translate(-0.086 -1.486)",
    fill: "#102d6f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32608",
    "data-name": "Group 32608",
    transform: "translate(0 0)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32607",
    "data-name": "Group 32607",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32606",
    "data-name": "Group 32606",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34709",
    "data-name": "Path 34709",
    d: "M14.023,0A14.039,14.039,0,0,0,0,14.023c0,6.262,9.384,17.634,13.177,21.956.327.375.605.7.845.96.24-.259.519-.586.845-.96,3.784-4.322,13.168-15.694,13.168-21.956A14.031,14.031,0,0,0,14.023,0m0,22.129a8.9,8.9,0,1,1,8.9-8.9,8.917,8.917,0,0,1-8.9,8.9",
    transform: "translate(0 0)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34710",
    "data-name": "Path 34710",
    d: "M21.295,13.482A6.987,6.987,0,1,1,14.312,6.5a6.989,6.989,0,0,1,6.982,6.982",
    transform: "translate(-0.29 -0.257)",
    fill: "#4972f4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_34711",
    "data-name": "Path 34711",
    d: "M21.295,13.482A6.987,6.987,0,1,1,14.312,6.5a6.989,6.989,0,0,1,6.982,6.982",
    transform: "translate(-0.29 -0.257)",
    fill: "#ffb063"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoa);
export default __webpack_public_path__ + "static/media/poa.020c11bc0353d376e2805c4c5f13759e.svg";
export { ForwardRef as ReactComponent };